import React from "react";
import { Container, Typography } from "@mui/material";
import BillingLayout from "../../layouts/BillingLayout"; // or your BillingStaffLayout

const BillingDashboard = () => (
  <BillingLayout>
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Billing Staff Dashboard
      </Typography>
      {/* billing-staff-specific widgets go here */}
    </Container>
  </BillingLayout>
);

export default BillingDashboard;
